// import React, { useState,useEffect } from 'react';
// // ...existing imports...
// import { Modal, Button } from 'react-bootstrap';
// import { NavLink ,useLocation} from 'react-router-dom'; // Change Link to NavLink
// import { FaFacebookF, FaLinkedinIn, FaSquareXTwitter, FaYoutube } from 'react-icons/fa';
// import mainLogo from './assets/images/logo2.jpg';

// const Header = () => {
//     const location = useLocation();



//    // Add this function to handle active class
//   const getNavLinkClass = ({ isActive }) => {
//     return `nav-link ${isActive ? 'active' : ''}`;
//   };

// const handleNavLinkClick = (event) => {
//   // Close offcanvas if open
//   const closeBtn = document.querySelector('.btn-header-nav-toggle');
//   if (closeBtn) {
//     closeBtn.click();
//   }

//   // Find the top-level parent dropdown <li>
//   const parentDropdownLi = event.target.closest('.nav-item.dropdown');

//   // Remove class from all dropdown parents first
//   document.querySelectorAll('.nav-item.dropdown').forEach((li) =>
//     li.classList.remove('nav-ul-clicked')
//   );

//   // Add class only to the clicked one
//   if (parentDropdownLi) {
//     parentDropdownLi.classList.add('nav-ul-clicked');
//   }
// };

// useEffect(() => {
//   const handleClickOutside = (e) => {
//     // If click is outside any dropdown <li>, remove class
//     const isInsideDropdown = e.target.closest('.nav-item.dropdown');

//     if (!isInsideDropdown) {
//       document.querySelectorAll('.nav-item.dropdown').forEach((li) =>
//         li.classList.remove('nav-ul-clicked')
//       );
//     }
//   };

//   document.addEventListener('click', handleClickOutside);
//   return () => document.removeEventListener('click', handleClickOutside);
// }, []);


//   useEffect(() => {
//   if (!location.pathname.startsWith("/services")) {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }
//   }, [location.pathname]);

//   // ...existing state and hooks...
//   const [searchQuery, setSearchQuery] = useState('');

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     // Replace this with your actual search logic or navigation
//     alert(`Searching for: ${searchQuery}`);
//     // Example: navigate(`/search?query=${encodeURIComponent(searchQuery)}`);
//   };

//   return (
//     <>
//     <div className="bg-gray-de text-white py-2">
//         <div className='container max-1330'>
//             <div className='row align-items-center'>
//                 <div className='col-sm'>
//                     <span className='text-dark-blue'><strong>Maritime Emergency Number :</strong> 021-938-3300</span>
//                 </div>
//                 <div className='col-sm-auto '>
//                     <div className='row g-3 align-items-center'>
//                       {/* <div className="col-auto"><a href="#" className="text-primary-green text-decoration-none">Register / Log in</a></div> */}
//                       <div className="col-auto">
//                         <ul className='social-icons d-flex list-unstyled mb-0'>
//                           <li><a target='_blank' href='https://www.facebook.com/SAMaritimeSafetyAuthority/'><FaFacebookF /></a></li>
//                           <li><a target='_blank' href='https://www.linkedin.com/'><FaLinkedinIn /></a></li>
//                           <li><a target='_blank' href='https://x.com/SAMSAMARITIME'><i className="bi bi-twitter-x"></i></a></li>
//                           <li><a target='_blank' href='https://www.youtube.com/channel/UCIqmnYu3osp-T1A2XWBp-3Q'><FaYoutube /></a></li>
//                         </ul>
//                       </div>

//                     </div>
//                 </div>
//             </div>
//         </div>
//       </div>
//     <header>

//         <nav className="navbar navbar-expand-xl py-md-3 bg-white">
//   <div className="container max-1330 justify-content-xl-start">
//     <div className='me-lg-5 pe-lg-5'>
//       <NavLink className="navbar-brand m-0" href="/">
//       <img
//               src={mainLogo}
//               alt="SAMSA Logo"
//               width={80}
//             />
//     </NavLink>
//     </div>
//     {/* <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//       <span className="navbar-toggler-icon"></span>
//     </button> */}


//     <div  className="offcanvas-xl offcanvas-end  pb-3 pb-md-0" data-bs-scroll="true" id="navbarSupportedContent" aria-labelledby="offcanvasResponsiveLabel">
//       <div className="offcanvas-header d-xl-none px-3 px-xl-0">
//                   {/* <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">
//                      <img
//                     src={mainLogo}
//                     alt="SAMSA Logo"
//                     width={70}
//                   />
//                   </h5> */}
//                   <button
//                     type="button"
//                     className="btn-close btn-header-nav-toggle"
//                     data-bs-dismiss="offcanvas"
//                     data-bs-target="#navbarSupportedContent"
//                     aria-label="Close"
//                   ></button>
//                 </div>
//                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
//                <li className="nav-item">
//                   <NavLink className={getNavLinkClass}  to="/" >
//                     Home
//                   </NavLink>
//                 </li>
//                 <li className="nav-item dropdown">
//                   <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/about"  onClick={handleNavLinkClick} >
//                     About Us
//                   </NavLink>
//                   <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAbout" aria-expanded="false" aria-controls="collapseAbout">
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapseAbout">
//                   {[
//                     { section: "vision-mission", label: "Vision and Mission" },
//                     { section: "governing-structure", label: "Governing Structure" },
//                     { section: "management-team", label: "Management Team" },
//                     { section: "corporate-social-investments", label: "Corporate Social Investments" },
//                     { section: "social-mapping", label: "Social Mapping" },
//                   ].map(({ section, label }) => (
//                     <li key={section}>
//                       <NavLink
//                         className="dropdown-item"
//                         to={`/about?section=${section}`}
//                         onClick={() => {
//                           const closeBtn = document.querySelector(".btn-header-nav-toggle");
//                           if (closeBtn) closeBtn.click();
//                         }}
//                       >
//                         {label}
//                       </NavLink>
//                     </li>
//                   ))}
//                   </ul>
//                 </li>
//                 {/*<li className="nav-item">
//                    <NavLink className={'nav-link'} to="#" >
//                     Verifications
//                   </NavLink> 
//                   <button className='nav-link' onClick={handleModalShow}>Verifications</button>
//                 </li>*/}
//                 <li className="nav-item dropdown">
//                   <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/services"  onClick={handleNavLinkClick} >
//                     Services
//                   </NavLink>
//                   <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseServices" aria-expanded="false" aria-controls="collapseServices">
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapseServices">
//                   {[
//                     { section: "seafarer-overview", label: "Seafarer Services" },
//                     { section: "vessels-overview", label: "Small Vessels Safety" },
//                     { section: "watch-overview", label: "Sea Watch & Response" },
//                     { section: "shipping-overview", label: "Shipping Safety" },
//                     { section: "naval-overview", label: "Naval Architecture" },
//                     { section: "registry-overview", label: "Ship Registry" },
//                     { section: "fishing-overview", label: "Fishing" },
//                     { section: "forms-all", label: "Forms" },
//                     { section: "audit-overview", label: "Audit And Accreditation" },
//                     // { section: "verifications", label: "Verifications" },
//                   ].map(({ section, label }) => (
//                     <li key={section}>
//                       <NavLink
//                         className="dropdown-item"
//                         to={`/services?section=${section}`}
//                         onClick={handleNavLinkClick}
//                       >
//                         {label}
//                       </NavLink>
//                     </li>
//                   ))}
//                 </ul>
//                 </li>

//                 <li className="nav-item">
//                   <NavLink className={getNavLinkClass}  to="/welfare" >
//                    Seafarer Welfare
//                   </NavLink>
//                 </li>

//                 <li className="nav-item dropdown">
//                   <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/legislation" onClick={handleNavLinkClick}>
//                     Legislation
//                   </NavLink>
//                   <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLegislation" aria-expanded="false" aria-controls="collapseLegislation">
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                    <ul className="collapse" id="collapseLegislation">
//                     {[
//                       { section: "acts-overview", label: "Acts and Regulations" },
//                       { section: "marine-related", label: "Marine Related" },
//                       { section: "training-standards", label: "Training Standards Codes" },
//                       { section: "intl-instruments", label: "International Instruments" },
//                     ].map(({ section, label }) => (
//                       <li key={section}>
//                         <NavLink
//                           className="dropdown-item"
//                           to={`/legislation?section=${section}`}
//                           onClick={handleNavLinkClick}
//                         >
//                           {label}
//                         </NavLink>
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//                 <li className="nav-item dropdown">
//                   <NavLink
//                     className={({ isActive }) =>
//                       `nav-link dropdown-toggle ${isActive ? 'active' : ''}`
//                     }
//                     to="/press-room"
//                     onClick={handleNavLinkClick}
//                   >
//                     Press Room
//                   </NavLink>
//                   <button
//                     className="btn btn-toggle"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#collapsePressRoom"
//                     aria-expanded="false"
//                     aria-controls="collapsePressRoom"
//                   >
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapsePressRoom">
//                     {[
//                       { section: "latest-news", label: "Latest News" },
//                       { section: "events-calendar", label: "Events Calendar" },
//                       { section: "publications", label: "Publications" },
//                       { section: "gallery", label: "Gallery" },
//                       { section: "day-of-the-seafarer", label: "Day of the Seafarer" },
//                     ].map(({ section, label }) => (
//                       <li key={section}>
//                         <NavLink
//                           className="dropdown-item"
//                           to={`/press-room?section=${section}`}
//                           onClick={handleNavLinkClick}
//                         >
//                           {label}
//                         </NavLink>
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//                 <li className="nav-item dropdown">
//                   <NavLink
//                     className={({ isActive }) =>
//                       `nav-link dropdown-toggle ${isActive ? 'active' : ''}`
//                     }
//                     to="/opportunities"
//                     onClick={handleNavLinkClick}
//                   >
//                     Opportunities
//                   </NavLink>
//                   <button
//                     className="btn btn-toggle"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#collapseOpportunities"
//                     aria-expanded="false"
//                     aria-controls="collapseOpportunities"
//                   >
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapseOpportunities">
//                     {[
//                       { section: "vacancies", label: "Vacancies" },
//                       { section: "maritime-careers", label: "Maritime Careers" },
//                       { section: "cadetship", label: "Cadetship" },
//                       { section: "supply-chain", label: "Supply Chain Management" },
//                       { section: "maritime-studies", label: "Maritime Studies" },
//                     ].map(({ section, label }) => (
//                       <li key={section}>
//                         <NavLink
//                           className="dropdown-item"
//                           to={`/opportunities?section=${section}`}
//                           onClick={handleNavLinkClick}
//                         >
//                           {label}
//                         </NavLink>
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//                 <li className="nav-item dropdown">
//                   <NavLink
//                     className={({ isActive }) =>
//                       `nav-link dropdown-toggle ${isActive ? 'active' : ''}`
//                     }
//                     to="/contact-us"
//                     onClick={handleNavLinkClick}
//                   >
//                     Contact Us
//                   </NavLink>
//                   <button
//                     className="btn btn-toggle"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#collapseContactUs"
//                     aria-expanded="false"
//                     aria-controls="collapseContactUs"
//                   >
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapseContactUs">
//                     {[
//                       { section: "query-form", label: "Query Form" },
//                       { section: "samsa-offices", label: "SAMSA Offices" },
//                       { section: "emergency-number", label: "Emergency Number" },
//                     ].map(({ section, label }) => (
//                       <li key={section}>
//                         <NavLink
//                           className="dropdown-item"
//                           to={`/contact-us?section=${section}`}
//                           onClick={handleNavLinkClick}
//                         >
//                           {label}
//                         </NavLink>
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//       </ul>  
//     </div>

//     <div className='searchWrap ms-auto ms-xl-3'>
//         <form className="d-flex" role="search" onSubmit={handleSearchSubmit}>
//           <input
//             className="form-control"
//             type="search"
//             placeholder="Search this site"
//             aria-label="Search"
//             value={searchQuery}
//             onChange={handleSearchChange}
//           />
//           <button className="btn-search bi bi-search" type="submit"></button>
//         </form>
//       </div>

//     <i className="bi bi-list  border-0 ms-2 font-32 d-block d-xl-none" data-bs-toggle="offcanvas" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"></i>
//   </div>
// </nav>
//     </header>


//     </>
//   );
// };

// export default Header;

// import React, { useState,useEffect } from 'react';
// // ...existing imports...
// import { Modal, Button } from 'react-bootstrap';
// import { NavLink ,useLocation} from 'react-router-dom'; // Change Link to NavLink
// import { FaFacebookF, FaLinkedinIn, FaSquareXTwitter, FaYoutube } from 'react-icons/fa';
// import mainLogo from './assets/images/logo2.jpg';

// const Header = () => {
//     const location = useLocation();



//    // Add this function to handle active class
//   const getNavLinkClass = ({ isActive }) => {
//     return `nav-link ${isActive ? 'active' : ''}`;
//   };

// const handleNavLinkClick = (event) => {
//   // Close offcanvas if open
//   const closeBtn = document.querySelector('.btn-header-nav-toggle');
//   if (closeBtn) {
//     closeBtn.click();
//   }

//   // Find the top-level parent dropdown <li>
//   const parentDropdownLi = event.target.closest('.nav-item.dropdown');

//   // Remove class from all dropdown parents first
//   document.querySelectorAll('.nav-item.dropdown').forEach((li) =>
//     li.classList.remove('nav-ul-clicked')
//   );

//   // Add class only to the clicked one
//   if (parentDropdownLi) {
//     parentDropdownLi.classList.add('nav-ul-clicked');
//   }
// };

// useEffect(() => {
//   const handleClickOutside = (e) => {
//     // If click is outside any dropdown <li>, remove class
//     const isInsideDropdown = e.target.closest('.nav-item.dropdown');

//     if (!isInsideDropdown) {
//       document.querySelectorAll('.nav-item.dropdown').forEach((li) =>
//         li.classList.remove('nav-ul-clicked')
//       );
//     }
//   };

//   document.addEventListener('click', handleClickOutside);
//   return () => document.removeEventListener('click', handleClickOutside);
// }, []);


//   useEffect(() => {
//   if (!location.pathname.startsWith("/services")) {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }
//   }, [location.pathname]);

//   // ...existing state and hooks...
//   const [searchQuery, setSearchQuery] = useState('');

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     // Replace this with your actual search logic or navigation
//     alert(`Searching for: ${searchQuery}`);
//     // Example: navigate(`/search?query=${encodeURIComponent(searchQuery)}`);
//   };

//   return (
//     <>
//     <div className="bg-gray-de text-white py-2">
//         <div className='container max-1330'>
//             <div className='row align-items-center'>
//                 <div className='col-sm'>
//                     <span className='text-dark-blue'><strong>Maritime Emergency Number :</strong> 021-938-3300</span>
//                 </div>
//                 <div className='col-sm-auto '>
//                     <div className='row g-3 align-items-center'>
//                       {/* <div className="col-auto"><a href="#" className="text-primary-green text-decoration-none">Register / Log in</a></div> */}
//                       <div className="col-auto">
//                         <ul className='social-icons d-flex list-unstyled mb-0'>
//                           <li><a target='_blank' href='https://www.facebook.com/SAMaritimeSafetyAuthority/'><FaFacebookF /></a></li>
//                           <li><a target='_blank' href='https://www.linkedin.com/'><FaLinkedinIn /></a></li>
//                           <li><a target='_blank' href='https://x.com/SAMSAMARITIME'><i className="bi bi-twitter-x"></i></a></li>
//                           <li><a target='_blank' href='https://www.youtube.com/channel/UCIqmnYu3osp-T1A2XWBp-3Q'><FaYoutube /></a></li>
//                         </ul>
//                       </div>

//                     </div>
//                 </div>
//             </div>
//         </div>
//       </div>
//     <header>

//         <nav className="navbar navbar-expand-xl py-md-3 bg-white">
//   <div className="container max-1330 justify-content-xl-start">
//     <div className='me-lg-5 pe-lg-5'>
//       <NavLink className="navbar-brand m-0" href="/">
//       <img
//               src={mainLogo}
//               alt="SAMSA Logo"
//               width={80}
//             />
//     </NavLink>
//     </div>
//     {/* <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//       <span className="navbar-toggler-icon"></span>
//     </button> */}


//     <div  className="offcanvas-xl offcanvas-end  pb-3 pb-md-0" data-bs-scroll="true" id="navbarSupportedContent" aria-labelledby="offcanvasResponsiveLabel">
//       <div className="offcanvas-header d-xl-none px-3 px-xl-0">
//                   {/* <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">
//                      <img
//                     src={mainLogo}
//                     alt="SAMSA Logo"
//                     width={70}
//                   />
//                   </h5> */}
//                   <button
//                     type="button"
//                     className="btn-close btn-header-nav-toggle"
//                     data-bs-dismiss="offcanvas"
//                     data-bs-target="#navbarSupportedContent"
//                     aria-label="Close"
//                   ></button>
//                 </div>
//                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
//                <li className="nav-item">
//                   <NavLink className={getNavLinkClass}  to="/" >
//                     Home
//                   </NavLink>
//                 </li>
//                 <li className="nav-item dropdown">
//                   <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/about"  onClick={handleNavLinkClick} >
//                     About Us
//                   </NavLink>
//                   <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAbout" aria-expanded="false" aria-controls="collapseAbout">
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapseAbout">
//                   {[
//                     { section: "vision-mission", label: "Vision and Mission" },
//                     { section: "governing-structure", label: "Governing Structure" },
//                     { section: "management-team", label: "Management Team" },
//                     { section: "corporate-social-investments", label: "Corporate Social Investments" },
//                     { section: "social-mapping", label: "Social Mapping" },
//                   ].map(({ section, label }) => (
//                     <li key={section}>
//                       <NavLink
//                         className="dropdown-item"
//                         to={`/about?section=${section}`}
//                         onClick={() => {
//                           const closeBtn = document.querySelector(".btn-header-nav-toggle");
//                           if (closeBtn) closeBtn.click();
//                         }}
//                       >
//                         {label}
//                       </NavLink>
//                     </li>
//                   ))}
//                   </ul>
//                 </li>
//                 {/*<li className="nav-item">
//                    <NavLink className={'nav-link'} to="#" >
//                     Verifications
//                   </NavLink> 
//                   <button className='nav-link' onClick={handleModalShow}>Verifications</button>
//                 </li>*/}
//                 <li className="nav-item dropdown">
//                   <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/services"  onClick={handleNavLinkClick} >
//                     Services
//                   </NavLink>
//                   <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseServices" aria-expanded="false" aria-controls="collapseServices">
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapseServices">
//                   {[
//                     { section: "seafarer-overview", label: "Seafarer Services" },
//                     { section: "vessels-overview", label: "Small Vessels Safety" },
//                     { section: "watch-overview", label: "Sea Watch & Response" },
//                     { section: "shipping-overview", label: "Shipping Safety" },
//                     { section: "naval-overview", label: "Naval Architecture" },
//                     { section: "registry-overview", label: "Ship Registry" },
//                     { section: "fishing-overview", label: "Fishing" },
//                     { section: "forms-all", label: "Forms" },
//                     { section: "audit-overview", label: "Audit And Accreditation" },
//                     // { section: "verifications", label: "Verifications" },
//                   ].map(({ section, label }) => (
//                     <li key={section}>
//                       <NavLink
//                         className="dropdown-item"
//                         to={`/services?section=${section}`}
//                         onClick={handleNavLinkClick}
//                       >
//                         {label}
//                       </NavLink>
//                     </li>
//                   ))}
//                 </ul>
//                 </li>

//                 <li className="nav-item">
//                   <NavLink className={getNavLinkClass}  to="/welfare" >
//                    Seafarer Welfare
//                   </NavLink>
//                 </li>

//                 <li className="nav-item dropdown">
//                   <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/legislation" onClick={handleNavLinkClick}>
//                     Legislation
//                   </NavLink>
//                   <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLegislation" aria-expanded="false" aria-controls="collapseLegislation">
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                    <ul className="collapse" id="collapseLegislation">
//                     {[
//                       { section: "acts-overview", label: "Acts and Regulations" },
//                       { section: "marine-related", label: "Marine Related" },
//                       { section: "training-standards", label: "Training Standards Codes" },
//                       { section: "intl-instruments", label: "International Instruments" },
//                     ].map(({ section, label }) => (
//                       <li key={section}>
//                         <NavLink
//                           className="dropdown-item"
//                           to={`/legislation?section=${section}`}
//                           onClick={handleNavLinkClick}
//                         >
//                           {label}
//                         </NavLink>
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//                 <li className="nav-item dropdown">
//                   <NavLink
//                     className={({ isActive }) =>
//                       `nav-link dropdown-toggle ${isActive ? 'active' : ''}`
//                     }
//                     to="/press-room"
//                     onClick={handleNavLinkClick}
//                   >
//                     Press Room
//                   </NavLink>
//                   <button
//                     className="btn btn-toggle"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#collapsePressRoom"
//                     aria-expanded="false"
//                     aria-controls="collapsePressRoom"
//                   >
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapsePressRoom">
//                     {[
//                       { section: "latest-news", label: "Latest News" },
//                       { section: "events-calendar", label: "Events Calendar" },
//                       { section: "publications", label: "Publications" },
//                       { section: "gallery", label: "Gallery" },
//                       { section: "day-of-the-seafarer", label: "Day of the Seafarer" },
//                     ].map(({ section, label }) => (
//                       <li key={section}>
//                         <NavLink
//                           className="dropdown-item"
//                           to={`/press-room?section=${section}`}
//                           onClick={handleNavLinkClick}
//                         >
//                           {label}
//                         </NavLink>
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//                 <li className="nav-item dropdown">
//                   <NavLink
//                     className={({ isActive }) =>
//                       `nav-link dropdown-toggle ${isActive ? 'active' : ''}`
//                     }
//                     to="/opportunities"
//                     onClick={handleNavLinkClick}
//                   >
//                     Opportunities
//                   </NavLink>
//                   <button
//                     className="btn btn-toggle"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#collapseOpportunities"
//                     aria-expanded="false"
//                     aria-controls="collapseOpportunities"
//                   >
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapseOpportunities">
//                     {[
//                       { section: "vacancies", label: "Vacancies" },
//                       { section: "maritime-careers", label: "Maritime Careers" },
//                       { section: "cadetship", label: "Cadetship" },
//                       { section: "supply-chain", label: "Supply Chain Management" },
//                       { section: "maritime-studies", label: "Maritime Studies" },
//                     ].map(({ section, label }) => (
//                       <li key={section}>
//                         <NavLink
//                           className="dropdown-item"
//                           to={`/opportunities?section=${section}`}
//                           onClick={handleNavLinkClick}
//                         >
//                           {label}
//                         </NavLink>
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//                 <li className="nav-item dropdown">
//                   <NavLink
//                     className={({ isActive }) =>
//                       `nav-link dropdown-toggle ${isActive ? 'active' : ''}`
//                     }
//                     to="/contact-us"
//                     onClick={handleNavLinkClick}
//                   >
//                     Contact Us
//                   </NavLink>
//                   <button
//                     className="btn btn-toggle"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#collapseContactUs"
//                     aria-expanded="false"
//                     aria-controls="collapseContactUs"
//                   >
//                     <i className="bi bi-chevron-right"></i>
//                   </button>
//                   <ul className="collapse" id="collapseContactUs">
//                     {[
//                       { section: "query-form", label: "Query Form" },
//                       { section: "samsa-offices", label: "SAMSA Offices" },
//                       { section: "emergency-number", label: "Emergency Number" },
//                     ].map(({ section, label }) => (
//                       <li key={section}>
//                         <NavLink
//                           className="dropdown-item"
//                           to={`/contact-us?section=${section}`}
//                           onClick={handleNavLinkClick}
//                         >
//                           {label}
//                         </NavLink>
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//       </ul>  
//     </div>

//     {/* <div className='searchWrap ms-auto ms-xl-3'>
//         <form className="d-flex" role="search" onSubmit={handleSearchSubmit}>
//           <input
//             className="form-control"
//             type="search"
//             placeholder="Search this site"
//             aria-label="Search"
//             value={searchQuery}
//             onChange={handleSearchChange}
//           />
//           <button className="btn-search bi bi-search" type="submit"></button>
//         </form>
//       </div> */}

//     <i className="bi bi-list  border-0 ms-2 font-32 d-block d-xl-none" data-bs-toggle="offcanvas" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"></i>
//   </div>

// </nav>
//     </header>


//     </>
//   );
// };

// export default Header;


import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import mainLogo from './assets/images/logo2.jpg';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const getNavLinkClass = ({ isActive }) => `nav-link ${isActive ? 'active' : ''}`;

  // const handleNavLinkClick = (event) => {
  //   const closeBtn = document.querySelector('.btn-header-nav-toggle');
  //   if (closeBtn) closeBtn.click();

  //   const parentDropdownLi = event.target.closest('.nav-item.dropdown');
  //   document.querySelectorAll('.nav-item.dropdown').forEach((li) =>
  //     li.classList.remove('nav-ul-clicked')
  //   );

  //   if (parentDropdownLi) {
  //     parentDropdownLi.classList.add('nav-ul-clicked');
  //   }


  // };

  const handleNavLinkClick = (event, section) => {
    // 1. Handle PDF links (open in new tab)
    if (section?.endsWith('.pdf')) {
      event.preventDefault(); // Stop React Router navigation
      const pdfUrl = `${window.location.origin}${section}`; // Full URL
      window.open(pdfUrl, '_blank'); // Open PDF directly
      return; // Exit early (skip dropdown logic for PDFs)
    }

    // 2. Existing dropdown menu logic (for non-PDF links)
    const closeBtn = document.querySelector('.btn-header-nav-toggle');
    if (closeBtn) closeBtn.click();

    const parentDropdownLi = event.target.closest('.nav-item.dropdown');
    document.querySelectorAll('.nav-item.dropdown').forEach((li) =>
      li.classList.remove('nav-ul-clicked')
    );

    if (parentDropdownLi) {
      parentDropdownLi.classList.add('nav-ul-clicked');
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const isInsideDropdown = e.target.closest('.nav-item.dropdown');
      if (!isInsideDropdown) {
        document.querySelectorAll('.nav-item.dropdown').forEach((li) =>
          li.classList.remove('nav-ul-clicked')
        );
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    if (!location.pathname.startsWith("/services")) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const trimmed = searchQuery.trim();
    if (trimmed.length > 0) {
      navigate(`/search?query=${encodeURIComponent(trimmed)}`);
    }
  };

  return (
    <>
      <div className="bg-gray-de text-white py-2">
        <div className="container max-1330">
          <div className="row align-items-center">
            <div className="col-sm">
              <span className="text-dark-blue"><strong>Maritime Emergency Number :</strong> 021-938-3300</span>
            </div>
            <div className="col-sm-auto">
              <ul className="social-icons d-flex list-unstyled mb-0">
                <li><a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/SAMaritimeSafetyAuthority/"><FaFacebookF /></a></li>
                <li><a target="_blank" rel="noopener noreferrer" href="https://za.linkedin.com/company/samsa"><FaLinkedinIn /></a></li>
                <li><a target="_blank" rel="noopener noreferrer" href="https://x.com/SAMSAMARITIME"><i className="bi bi-twitter-x"></i></a></li>
                <li><a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCIqmnYu3osp-T1A2XWBp-3Q"><FaYoutube /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <header>
        <nav className="navbar navbar-expand-xl py-md-3 bg-white">
          <div className="container max-1330 justify-content-xl-start">
            <div className="me-lg-5" style={{ marginRight: '2rem !important' }}>
              <NavLink className="navbar-brand m-0" to="/">
                <img src={mainLogo} alt="SAMSA Logo" width={80} />
              </NavLink>
            </div>

            <div className="offcanvas-xl offcanvas-end pb-3 pb-md-0" data-bs-scroll="true" id="navbarSupportedContent" aria-labelledby="offcanvasResponsiveLabel">
              <div className="offcanvas-header d-xl-none px-3 px-xl-0">
                <button
                  type="button"
                  className="btn-close btn-header-nav-toggle"
                  data-bs-dismiss="offcanvas"
                  data-bs-target="#navbarSupportedContent"
                  aria-label="Close"
                ></button>
              </div>

              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <NavLink className={getNavLinkClass} to="/">Home</NavLink>
                </li>

                <li className="nav-item dropdown">
                  <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/about" onClick={handleNavLinkClick}>
                    About Us
                  </NavLink>
                  <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAbout">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                  <ul className="collapse" id="collapseAbout">
                    {[
                      { section: "vision-mission", label: "Vision and Mission" },
                      { section: "governing-structure", label: "Governing Structure" },
                      { section: "management-team", label: "Management Team" },
                      // { section: "corporate-social-investments", label: "Corporate Social Investments" },
                      // { section: "social-mapping", label: "CSI Projects" },
                      // { section: "CSI-Projects", label: "CSI Projects" },
                    ].map(({ section, label }) => (
                      <li key={section}>
                        <NavLink className="dropdown-item" to={`/about?section=${section}`} onClick={handleNavLinkClick}>
                          {label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>

                <li className="nav-item dropdown">
                  <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/services" onClick={handleNavLinkClick}>
                    Services
                  </NavLink>
                  <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseServices">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                  <ul className="collapse" id="collapseServices">
                    {[
                      { section: "seafarer-overview", label: "Seafarer Services" },
                     
                      { section: "Mosh-OverviewTab", label: "OHS" },

                      { section: "vessels-overview", label: "Small Vessels Safety" },
                      { section: "watch-overview", label: "Sea Watch & Response" },
                      { section: "shipping-overview", label: "Shipping Safety" },
                      { section: "naval-overview", label: "Naval Architecture" },
                      { section: "registry-overview", label: "Ship Registry" },
                      { section: "fishing-overview", label: "Fishing" },
                      { section: "/Documents/SmallVesselMarineIncidentReportForm.pdf", label: "Incident Reporting Form" },
                     { section: "forms-all", label: "Forms" },
                      { section: "audit-overview", label: "Audit And Accreditation" },
                      { section: "OffshoreBunker-Overview", label: "Offshore Bunker" },
                    // ].map(({ section, label }) => (
                    //   <li key={section}>
                    //     <NavLink className="dropdown-item" to={`/services?section=${section}`} onClick={handleNavLinkClick}>
                    //       {label}
                    //     </NavLink>
                    //   </li>
                    // ))}

                    ].map(({ section, label }) => (
                      <li key={section}>
                        <NavLink
                          className="dropdown-item"
                          to={`/services?section=${section}`}
                          onClick={(e) => handleNavLinkClick(e, section)}  // Pass `section` to handler
                        >
                          {label}
                        </NavLink>
                      </li>
                    ))}



                  </ul>
                </li>

                {/* <li className="nav-item">
                  <NavLink className={getNavLinkClass} to="/welfare">Seafarer Welfare</NavLink>

                </li> */}

                <li className="nav-item dropdown">

                  <NavLink className={({ isActive }) =>
                    `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/welfare" onClick={handleNavLinkClick}>
                    Seafarer Welfare
                  </NavLink>
                  <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWelfare">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                  <ul className="collapse" id="collapseWelfare">
                    {[
                      { section: "OverviewTab", label: "About seafarer welfare" },
                      { section: "Welfare-Services", label: "Welfare Services" },
                      { section: "Crew-Complaints", label: "Crew Complaints" },
                      { section: "GBVOverviewTab", label: "GBV" },
                      // { section: "Wellbeing-Corner", label: "Wellbeing Corner" },
                      // { section: "Information-Corner", label: "Information Corner" },
                      // { section: "Seafarer-Stories", label: "Seafarer-Stories" },
                    ].map(({ section, label }) => (
                      <li key={section}>
                        <NavLink className="dropdown-item" to={`/welfare?section=${section}`} onClick={handleNavLinkClick}>
                          {label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>


                </li>




                <li className="nav-item dropdown">
                  <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/legislation" onClick={handleNavLinkClick}>
                    Legislation
                  </NavLink>
                  <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLegislation">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                  <ul className="collapse" id="collapseLegislation">
                    {[
                      { section: "acts-overview", label: "Acts and Regulations" },
                      { section: "marine-related", label: "Marine Related" },
                      { section: "training-standards", label: "Training Standards Codes" },
                      { section: "intl-instruments", label: "International Instruments" },
                      { section: "Draft-Regulations", label: "Draft Regulations" },
                      { section: "/Documents/SAMSA PAIA MANUAL 2024.pdf", label: "SAMSA PAIA MANUAL" },
                    ].map(({ section, label }) => (
                      <li key={section}>
                        <NavLink
                          className="dropdown-item"
                          to={`/legislation?section=${section}`}
                          onClick={(e) => handleNavLinkClick(e, section)}  // Pass `section` to handler
                        >
                          {label}
                        </NavLink>
                      </li>
                    ))}

                  </ul>
                </li>

                <li className="nav-item dropdown">
                  <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/press-room" onClick={handleNavLinkClick}>
                    Press Room
                  </NavLink>
                  <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePressRoom">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                  <ul className="collapse" id="collapsePressRoom">
                    {[
                      { section: "latest-news", label: "Latest News" },
                      { section: "events-calendar", label: "Events" },
                      { section: "publications", label: "Publications" },
                      // { section: "gallery", label: "Gallery" },
                      // { section: "day-of-the-seafarer", label: "Day of the Seafarer" },
                    ].map(({ section, label }) => (
                      <li key={section}>
                        <NavLink className="dropdown-item" to={`/press-room?section=${section}`} onClick={handleNavLinkClick}>
                          {label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>

                <li className="nav-item dropdown">
                  <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/opportunities" onClick={handleNavLinkClick}>
                    Opportunities
                  </NavLink>
                  <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOpportunities">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                  <ul className="collapse" id="collapseOpportunities">
                    {[
                      { section: "maritime-careers", label: "Maritime Careers" },
                      { section: "vacancies", label: "Vacancies" },
                      // { section: "cadetship", label: "Cadetship" },
                      { section: "supply-chain", label: "Supply Chain Management" },
                      // { section: "maritime-studies", label: "Maritime Studies" },
                    ].map(({ section, label }) => (
                      <li key={section}>
                        <NavLink className="dropdown-item" to={`/opportunities?section=${section}`} onClick={handleNavLinkClick}>
                          {label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>

                <li className="nav-item dropdown">
                  <NavLink className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`} to="/contact-us" onClick={handleNavLinkClick}>
                    Contact Us
                  </NavLink>
                  <button className="btn btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseContactUs">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                  <ul className="collapse" id="collapseContactUs">
                    {[
                      { section: "query-form", label: "Query Form" },
                      { section: "samsa-offices", label: "SAMSA Offices" },
                       { section: "Board-Ceo", label: "SAMSA Board and CEO" },
                      { section: "emergency-number", label: "Emergency Number" },
                      {section: "WHISTLE-BLOWING", label: "Whistle Blowing"},
                    ].map(({ section, label }) => (
                      <li key={section}>
                        <NavLink className="dropdown-item" to={`/contact-us?section=${section}`} onClick={handleNavLinkClick}>
                          {label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </div>

            <div className="searchWrap ms-auto ms-xl-3">
              <form className="d-flex" role="search" onSubmit={handleSearchSubmit}>
                <input
                  className="form-control"
                  type="search"
                  placeholder="Search "
                  aria-label="Search"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <button className="btn-search bi bi-search" type="submit"></button>
              </form>
            </div>

            <i className="bi bi-list border-0 ms-2 font-32 d-block d-xl-none"
              data-bs-toggle="offcanvas"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation">
            </i>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;

